async function getCreditData2(rootDocument) {
  const token = await login();

  const response = await fetch(
    `${baseUrl}/credit-service/credit?rootDocument=${rootDocument}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "X-Operator-ID": "frontend shopify",
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Erro ao buscar os dados de crédito: ${response.status}`);
  }

  return await response.json();
}

async function getRewardsDataMyAccount(cnpjR) {
  const token = await login();
  
  const response = await fetch(
    `${baseUrl}/credit-service/credit/rewards?document=${cnpjR}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  if (!response.ok) {
    console.error(`Erro ao buscar rewards: ${response.status}`);
    return;
  }

  return await response.json();
}

async function getPayments() {
  const activityBranch = getActivityBranch();
  const url = `${baseUrl}/credit-service/credit/available-payment-types?rootDocument=${cnpjC}&activityBranch=${activityBranch}`;

  try {
    const token = await login();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "X-Operator-ID": "frontend shopify",
      },
    });

    if (!response.ok) {
      console.error("Houve um erro na resposta da solicitação");
    }

    return response.json();
  } catch (error) {
    console.log("Ocorreu um erro ao solicitar meios de pagamento: " + error);
  }
}

function renderCreditData2(creditRecords) {
  const blocksContainer = document.querySelector(
    "#custom-credit-block-wrapper"
  );
  if (!blocksContainer) {
    console.error("❌ #custom-credit-block-wrapper não encontrado no DOM.");
    return;
  }

  let isDelinquent = false;
  for (const record of creditRecords) {
    if (record.isDelinquent) {
      isDelinquent = true;
      break;
    }
  }

  creditRecords.forEach((record) => {
    const isActive = record.active;
    const block = document.createElement("div");
    block.className = "credit-block";

    const creditNameContainer = document.createElement("div");
    creditNameContainer.className = "credit-name-container";

    let label = "";
    let logoUrl = "";
    let logoAlt = "";

    switch (record.paymentId) {
      case "FKW-CREDIT":
        label = "Crédito Lightera";
        logoUrl = "/cdn/shop/files/Logo_LIGHTERA_CREDITO_Mono.png";
        logoAlt = "Logo Crédito Lightera";
        break;
      case "FKW-CARD":
        label = "Lightera Card";
        logoUrl = "/cdn/shop/files/Logo_LIGHTERA_CARD_Mono.png";
        break;
      case "FKW-FLEX":
        label = "Lightera Flex";
        logoUrl = "/cdn/shop/files/Logo_LIGHTERA_FLEX_Mono.png";
        break;
      case "BRASILFACTORS":
        label = "Brasil Factors";
        break;
      default:
        label = record.paymentId
          .toLowerCase()
          .split(" ")
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(" ");
    }

    let creditName;
    let svgIcon;

    if (logoUrl) {
      creditName = document.createElement("img");
      creditName.src = logoUrl;
      creditName.classList.add("credit-payment-id-logo");
    } else {
      creditName = document.createElement("span");
      creditName.textContent = label;

      if (record.paymentId == "FKW-CREDIT") {
        svgIcon = document.getElementById("money-icon").cloneNode(true);
      } else {
        svgIcon = document.getElementById("credit-card-icon").cloneNode(true);
      }
      svgIcon.style.display = "inline";
    }

    const nameContainer = document.createElement("h2");
    nameContainer.className = "credit-name";
    nameContainer.appendChild(creditName);

    if (svgIcon) nameContainer.appendChild(svgIcon);

    creditNameContainer.appendChild(nameContainer);

    block.appendChild(creditNameContainer);

    const balanceContainer = document.createElement("div");
    balanceContainer.className = "credit-balance-wrapper";

    block.appendChild(balanceContainer);

    const balanceText = document.createElement("span");
    balanceText.textContent = isActive ? "Disponível" : "Indisponível";
    balanceContainer.appendChild(balanceText);

    const balanceValue = document.createElement("p");

    let balance = 0;

    if (!isDelinquent && isActive) balance = record.balance;

    balanceValue.textContent = `R$ ${parseFloat(balance).toLocaleString(
      "pt-BR",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )}`;
    balanceValue.className = "balance-value";

    balanceContainer.appendChild(balanceValue);
    blocksContainer.appendChild(block);
  });
}

function updateRewardsValueMyAccount(rewardsData) {
  const blocksContainer = document.querySelector(
    "#custom-credit-block-wrapper"
  );
  if (!blocksContainer) {
    console.error("❌ #custom-credit-block-wrapper não encontrado no DOM.");
    return;
  }

  const block = document.createElement("div");
  block.className = "rewards-block";
  block.setAttribute("data-page", "/pages/extrato-rewards");

  const creditNameContainer = document.createElement("div");
  creditNameContainer.className = "rewards-name-container";

  const rewards = document.createElement("h2");
  rewards.className = "credit-name";
  creditNameContainer.appendChild(rewards);

  const svgArrow = document.getElementById("arrow-right").cloneNode(true);
  svgArrow.style.display = "inline";
  svgArrow.style.height = "16px";
  svgArrow.style.width = "16px";

  creditNameContainer.appendChild(svgArrow);

  const svgIcon = document.getElementById("rewards-icon").cloneNode(true);
  svgIcon.style.display = "inline";

  const rewardsName = document.createElement("span");
  rewardsName.textContent = "Rewards";

  rewards.appendChild(svgIcon);
  rewards.appendChild(rewardsName);

  block.appendChild(creditNameContainer);

  const balanceContainer = document.createElement("div");
  balanceContainer.className = "credit-balance-wrapper";

  block.appendChild(balanceContainer);

  const balanceText = document.createElement("span");
  balanceText.textContent = "Saldo atual";

  balanceContainer.appendChild(balanceText);

  const rewardsValue = document.createElement("p");

  rewardsValue.textContent = `${parseFloat(
    rewardsData ? Math.round(rewardsData.balance) : 0
  ).toLocaleString("pt-BR")} pontos`;
  rewardsValue.className = "balance-value";

  block.addEventListener("click", async (event) => {
    if (block.classList.contains("logout-link")) return;

    event.preventDefault();
    const pageUrl = block.getAttribute("data-page");
    setActiveLink(block);

    try {
      const response = await fetch(pageUrl);
      if (!response.ok) throw new Error("Erro ao carregar a página.");

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const content = doc.querySelector("#page-account");

      const pageContent = document.getElementById("page-content");
      pageContent.innerHTML = content
        ? content.innerHTML
        : "<p>Conteúdo não encontrado.</p>";

      await loadRewardsTransactions(rewardsData);

      document.querySelectorAll(".sidebar .menu a").forEach((link) => {
        if (link.getAttribute("data-page") === "/pages/linha-de-credito") {
          link.classList.add("active");
        }
      });
    } catch (error) {
      console.error(error);
      document.getElementById("page-content").innerHTML =
        "<p>Erro ao carregar o conteúdo.</p>";
    }
  });

  balanceContainer.appendChild(rewardsValue);
  blocksContainer.prepend(block);
}

async function setRewardPoints() {
  const rewardsContainer = document.querySelector("#my-account-rewards-points");
  rewardsContainer.textContent = "Carregando...";
  const cnpjR = getCnpjR();

  try {
    if (!cnpjR) throw new Error("Não foi possível recuperar os rewards");

    const rewardsData = await getRewardsDataMyAccount(cnpjR);

    if (rewardsContainer) {
      const rewardsBadge = document.querySelector(
        "#my-account-rewards-category"
      );
      const rewardsBadgeText = document.querySelector(
        "#my-account-rewards-category-text"
      );

      // if (parseFloat(rewardsData.balance) >= 50000.0) {
      //   rewardsBadge.className = "my-account-rewards-category diamond";
      //   rewardsBadgeText.textContent = "Categoria Diamante";
      // } else if (parseFloat(rewardsData.balance) >= 10000.0) {
      //   rewardsBadge.className = "my-account-rewards-category gold";
      //   rewardsBadgeText.textContent = "Categoria Ouro";
      // } else if (parseFloat(rewardsData.balance) >= 180.0) {
      //   rewardsBadge.className = "my-account-rewards-category silver";
      //   rewardsBadgeText.textContent = "Categoria Prata";
      // }

      if (rewardsData) {
        const rewardsBalance = rewardsData.balance;
        const rewardsText = rewardsBalance === 1 ? "ponto" : "pontos";
        rewardsContainer.textContent = `${rewardsBalance.toLocaleString(
          "pt-BR"
        )} ${rewardsText}`;
        rewardsContainer.style.display = "flex";
      } else {
        rewardsContainer.textContent = "0 pontos";
      }
    } else {
      console.error("❌ Erro: #my-account-rewards-points não encontrado.");
    }
  } catch (error) {
    rewardsContainer.textContent = `0 pontos`;
  }
}

const getRewardsTransactions = async (
  rootdocument,
  startingDate,
  endingDate,
  accessToken
) => {
  const response = await fetch(
    `${baseUrl}/credit-service/credit/rewards/report?document=${rootdocument}&startingDate=${startingDate}&endingDate=${endingDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  if (!response.ok) {
    const errorDetails = await response.text();
    console.error(`Erro: ${errorDetails}`);
    const tableContainer = document.getElementById(
      "rewards-transactions-container"
    );
    tableContainer.innerHTML = ``;
    const noValuesElement = document.createElement("div");

    noValuesElement.textContent =
      "Não existem movimentações de Rewards nessa conta.";
    tableContainer.appendChild(noValuesElement);
    throw new Error(`Erro ao buscar Rewards: ${response.status}`);
  }

  return await response.json();
};

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = String(date.getHours());
  let minutes = String(date.getMinutes());
  let seconds = String(date.getSeconds());

  if (seconds.length < 2) {
    seconds = "0" + seconds;
  }
  if (minutes.length < 2) {
    minutes = "0" + minutes;
  }
  if (hours.length < 2) {
    hours = "0" + hours;
  }

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function reorderDateString(dateString) {
  const [datePart, timePart] = dateString.split("T");
  const [year, month, day] = datePart.split("-");
  const [hours, minutes] = timePart.split(":");

  return `${day}/${month}/${year} ${hours}:${minutes}:00`;
}

const loadRewardsTransactions = async () => {
  try {
    const tableContainer = document.querySelector(
      "#rewards-transactions-container"
    );

    tableContainer.innerHTML = ``;

    showMyAccountSpinner(tableContainer);

    if (typeof getRewardsTransactions !== "function") {
      console.error(
        "❌ Erro: getRewardsTransactions não está definido. Verifique a importação."
      );
      return;
    }

    const rewardsValue = document.querySelector("#my-account-rewards-points");
    const balanceRewardsLable = document.querySelector("#rewards-balance");
    balanceRewardsLable.textContent = `Saldo atual: ${rewardsValue.textContent}`;
    const cnpjR = getCnpjR();
    const startingDateSelector = document.querySelector("#start-date").value;
    const endingDateSelector = document.querySelector("#end-date").value;
    const now = new Date();
    const firstDayOfLastMonth = new Date(
      now.getFullYear(),
      now.getMonth() - 1,
      1
    );
    let endingDate;
    let startingDate;

    if (startingDateSelector) {
      startingDate = reorderDateString(startingDateSelector);
    } else {
      startingDate = formatDate(firstDayOfLastMonth);
      const startInput = document.querySelector("#start-date");
      if (startInput) {
        const isoDate = firstDayOfLastMonth.toISOString().slice(0, 16);
        startInput.value = isoDate;
      }
    }
    if (endingDateSelector) {
      endingDate = reorderDateString(endingDateSelector);
    } else {
      endingDate = formatDate(now);
      const endInput = document.querySelector("#end-date");
      if (endInput) {
        const isoDate = now.toISOString().slice(0, 16);
        endInput.value = isoDate;
      }
    }
    const accessToken = await login();
    const rewardsData = await getRewardsTransactions(
      cnpjR,
      startingDate,
      endingDate,
      accessToken
    );
    console.log("✅ Dados de recompensas carregados:", rewardsData);

    if (typeof renderRewardsTransactions === "function") {
      renderRewardsTransactions(rewardsData);
    } else {
      console.error(
        "❌ Erro: renderRewardsTransactions não está definido. Verifique a importação."
      );
    }
  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
  } finally {
  }
};

const renderRewardsTransactions = (rewardsRecords) => {
  const tableContainer = document.getElementById(
    "rewards-transactions-container"
  );

  if (!tableContainer) {
    console.error("❌ #rewards-transactions-container não encontrado no DOM.");
    return;
  }

  tableContainer.innerHTML = ``;

  const table = document.createElement("div");
  table.classList.add("rewards-table");

  const tableHead = document.createElement("div");
  tableHead.classList.add("rewards-table-head");

  const rewardsHeaderFirstHalf = document.createElement("div");
  rewardsHeaderFirstHalf.classList.add("rewards-table-part");

  const rewardsHeaderSecondHalf = document.createElement("div");
  rewardsHeaderSecondHalf.classList.add("rewards-table-part");

  const tableBody = document.createElement("div");
  tableBody.classList.add("rewards-table-body");

  const dataHeader = document.createElement("p");
  dataHeader.classList.add("rewards-date-header");
  dataHeader.textContent = "Data";

  const orderHeader = document.createElement("p");
  orderHeader.classList.add("rewards-order-header");
  orderHeader.textContent = "Pedido/NF";

  const statusHeader = document.createElement("p");
  statusHeader.classList.add("rewards-status-header");
  statusHeader.textContent = "Status";

  const pointsHeader = document.createElement("p");
  pointsHeader.classList.add("rewards-points-header");
  pointsHeader.textContent = "Pontos";
  
  const historyHeader = document.createElement("p");
  historyHeader.classList.add("rewards-history-header");
  historyHeader.textContent = "Histórico";

  const noteHeader = document.createElement("p");
  noteHeader.classList.add("rewards-note-header");
  noteHeader.textContent = "Nota de consumo";

  rewardsHeaderFirstHalf.appendChild(dataHeader);
  rewardsHeaderFirstHalf.appendChild(orderHeader);
  rewardsHeaderFirstHalf.appendChild(statusHeader);
  rewardsHeaderFirstHalf.appendChild(pointsHeader);
  rewardsHeaderFirstHalf.appendChild(historyHeader);
  rewardsHeaderSecondHalf.appendChild(noteHeader);

  tableHead.appendChild(rewardsHeaderFirstHalf);
  tableHead.appendChild(rewardsHeaderSecondHalf);

  table.appendChild(tableHead);
  table.appendChild(tableBody);

  const noValuesElement = document.createElement("div");

  if (rewardsRecords.length === 0) {
    noValuesElement.textContent =
      "Não existem movimentações de Rewards para o período selecionado.";
    tableContainer.appendChild(noValuesElement);

    return;
  }

  rewardsRecords.forEach((record) => {
    if (record.pending) return;
    const rewardsRow = document.createElement("div");
    rewardsRow.classList.add("rewards-table-row");

    const rewardsRowInit = document.createElement("div");
    rewardsRowInit.classList.add("rewards-table-part");

    const rewardsRowEnd = document.createElement("div");
    rewardsRowEnd.classList.add("rewards-table-part");

    const rewardsContentRow = document.createElement("div");
    rewardsContentRow.classList.add("rewards-table-content");

    const rewardNoteRow = document.createElement("div");
    rewardNoteRow.classList.add("reward-note-row");
    const rewardNoteElement = document.createElement("p");
    rewardNoteElement.textContent = record.note || "Sem nota de consumo";
    rewardNoteRow.appendChild(rewardNoteElement);

    const rewardsDateCell = document.createElement("p");
    rewardsDateCell.classList.add("rewards-date-cell");

    const rewardsNoteCell = document.createElement("p");
    rewardsNoteCell.classList.add("rewards-note-cell");

    const rewardsStatusCell = document.createElement("p");
    rewardsStatusCell.classList.add("rewards-status-cell");

    const rewardsPtsCell = document.createElement("p");
    rewardsPtsCell.classList.add("rewards-points-cell");

    const rewardsButtonCell = document.createElement("p");
    rewardsButtonCell.classList.add("rewards-button-cell");

    let showNote = false;

    const proposalAproveDate = document.createElement("p");
    proposalAproveDate.className = "credit-name";
    const aprovDate = new Date(record.processDate);
    aprovDate.setFullYear(aprovDate.getFullYear());
    rewardsDateCell.textContent = aprovDate.toLocaleDateString("pt-BR");

    let noteText = record.order;
    if (!record.order) {
      noteText = "Não vinculado a pedido ou NF";
    }
    rewardsNoteCell.textContent = noteText;

    let statusText = record.transaction;
    if (
      record.transaction === "credit_standard_ms" ||
      record.transaction === "credit_order_ms"
    ) {
      statusText = "Pontos gerados";
    } else if (
      record.transaction === "debit_standard_ms" ||
      record.transaction === "debit_order_ms"
    ) {
      statusText = "Pontos consumidos";
    }
    rewardsStatusCell.textContent = statusText;

    const amountText = `${parseFloat(record.amount).toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })} pts`;
    rewardsPtsCell.textContent = amountText;

    const arrowDown = document.getElementById("arrow-down").cloneNode(true);
    arrowDown.style.display = "inline";
    arrowDown.style.height = "16px";
    arrowDown.style.width = "16px";

    const arrowButton = document.createElement("button");
    arrowButton.classList.add("arrow-button");
    if (showNote) arrowButton.classList.add("up");
    arrowButton.appendChild(arrowDown);

    arrowButton.addEventListener("click", (event) => {
      event.preventDefault();
      showNote = !showNote;
      arrowButton.classList.toggle("up", showNote);
      rewardNoteRow.style.display = showNote ? "block" : "none";
    });

    rewardsButtonCell.appendChild(arrowButton);

    rewardsRowInit.appendChild(rewardsDateCell);
    rewardsRowInit.appendChild(rewardsNoteCell);
    rewardsRowInit.appendChild(rewardsStatusCell);
    rewardsRowInit.appendChild(rewardsPtsCell);
    rewardsRowEnd.appendChild(rewardsButtonCell);

    rewardsContentRow.appendChild(rewardsRowInit);
    rewardsContentRow.appendChild(rewardsRowEnd);

    rewardsRow.appendChild(rewardsContentRow);
    rewardsRow.appendChild(rewardNoteRow);

    tableBody.appendChild(rewardsRow);
  });

  table.appendChild(tableHead);
  table.appendChild(tableBody);
  tableContainer.appendChild(table);
};


async function loadCreditData2(creditData) {
  try {
    console.log("🔹 Iniciando loadCreditData2");

    const creditBlocksContainer = document.querySelector(
      "#custom-credit-block-wrapper"
    );
    if (creditBlocksContainer) {
      if (typeof renderCreditData2 === "function") {
        renderCreditData2(creditData.records);
      } else {
        console.error(
          "❌ Erro: renderCreditData2 não está definido. Verifique a importação."
        );
      }
    } else {
      console.error("❌ Erro: #custom-credit-block-wrapper não encontrado.");
    }
  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
  }
}

async function loadPaymentMethods(payments) {
  if (!payments.ok) {
    renderDefaultPayments();
    return;
  }

  const paymentMethods = await payments.json();

  renderPayments(paymentMethods.financing);
}

async function loadRewardsDataMyAccount(rewardsData) {
  try {
    console.log("🔹 Iniciando loadRewardsDataMyAccount");
    console.log("✅ CNPJ recebido:", cnpjR);

    // Verificar se a função getRewardsDataMyAccount está definida no contexto
    if (typeof getRewardsDataMyAccount !== "function") {
      console.error(
        "❌ Erro: getRewardsDataMyAccount não está definido. Verifique a importação."
      );
      return;
    }

    console.log("✅ Dados de rewards carregados:", rewardsData);

    // Aqui você pode usar a lógica para exibir os dados de rewards
    const rewardsContainer = document.querySelector(
      "#custom-credit-block-wrapper"
    );
    if (rewardsContainer) {
      if (typeof updateRewardsValueMyAccount === "function") {
        updateRewardsValueMyAccount(rewardsData);
      } else {
        console.error(
          "❌ Erro: updateRewardsValueMyAccount não está definido. Verifique a importação."
        );
      }
    } else {
      console.error("❌ Erro: #custom-credit-block-wrapper não encontrado.");
    }
  } catch (error) {
    updateRewardsValueMyAccount();
    console.error("❌ Erro ao carregar os dados de Rewards:", error);
  }
}

async function loadCreditRelatedData() {
  const creditContainer = document.querySelector(
    "#custom-credit-block-wrapper"
  );
  const financingContainer = document.querySelector(
    "#custom-financing-block-wrapper"
  );

  showMyAccountSpinner(creditContainer);
  showMyAccountSpinner(financingContainer);

  const cnpjR = getCnpjR();
  const cnpjC = getCnpjC();

  await waitForElement("#custom-credit-block-wrapper", 1000);

  try {
    if (!cnpjR) {
      document.querySelector("#custom-credit-block-wrapper").innerHTML =
        "Você ainda não possui valores disponíveis.";
      document.querySelector("#custom-financing-block-wrapper").innerHTML =
        "Você ainda não possui formas de pagamento disponíveis.";
      throw "Não foi possível obter os dados da empresa";
    }

    const rewardsDataPromise = fetchWithCache(
      `rewards-${cnpjR}`,
      getRewardsDataMyAccount,
      cnpjR
    );
    const creditDataPromise = fetchWithCache(
      `credit-${cnpjC}`,
      getCreditData2,
      cnpjC
    );
    const paymentsPromise = fetchWithCache("payments", getPayments); // Se dependente de token, use-o aqui

    const promiseCredit = creditDataPromise.then((res) => loadCreditData2(res));

    const promisePayments = paymentsPromise.then((res) =>
      loadPaymentMethods(res)
    );

    await Promise.all([promiseCredit, promisePayments, promiseRewards]);

    validateAvailableValues(creditContainer);
  } catch (error) {
    console.error("❌ Erro ao carregar dados de crédito:", error);
  } finally {
    removeMyAccountSpinner(creditContainer);
    removeMyAccountSpinner(financingContainer);
  }
}

function validateAvailableValues(container) {
  const creditBlocks = container.querySelectorAll(".credit-block");
  if (creditBlocks.length > 0) {
    return;
  }

  const noCreditText = document.createElement("span");
  noCreditText.textContent =
    "No momento, você não possui créditos disponíveis.";

  container.append(noCreditText);
}

const resetRewardsSummaryView = () => {
  const summaryBlock = document.querySelector("#rewards-summary-block");
  if (!summaryBlock) return;

  const summaryWrapper = summaryBlock.closest(".title-page-account-container") || summaryBlock;
  summaryWrapper.style.display = "";

  document.querySelectorAll(".rewards-full-statement").forEach((el) => {
    el.style.display = "none";
  });
};

const syncRewardsSummaryBalance = () => {
  const summaryBalanceValueEl = document.querySelector("#rewards-summary-balance-value");
  const rewardsValueEl = document.querySelector("#my-account-rewards-points");

  if (!summaryBalanceValueEl) return;

  const sourceReady =
    rewardsValueEl &&
    rewardsValueEl.textContent.trim() &&
    rewardsValueEl.textContent.trim() !== "Carregando...";

  if (sourceReady) {
    summaryBalanceValueEl.textContent = rewardsValueEl.textContent;
    return;
  }

  const cnpjR = getCnpjR();
  if (!cnpjR) return;

  getRewardsDataMyAccount(cnpjR)
    .then((rewardsData) => {
      const balance = rewardsData ? rewardsData.balance : 0;
      summaryBalanceValueEl.textContent = `${balance.toLocaleString("pt-BR")} pontos`;
    })
    .catch((error) => {
      console.error("❌ Erro ao carregar saldo do resumo de rewards:", error);
    });
};

const initRewardsSummary = () => {
  resetRewardsSummaryView();
  syncRewardsSummaryBalance();
};

document.addEventListener("click", (event) => {
  const summaryBlock = event.target.closest("#rewards-summary-block");
  if (!summaryBlock) return;

  event.preventDefault();

  document.querySelectorAll(".rewards-full-statement").forEach((el) => {
    el.style.display = "";
  });

  const summaryWrapper = summaryBlock.closest(".title-page-account-container") || summaryBlock;
  summaryWrapper.style.display = "none";
});